import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Dashboard } from '../../comum/modelos/dashboard';
import { DashboardsService } from '../dashboards.service';
import { ComumService } from '../../comum/comum.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { DashboardUsuario } from '../../comum/modelos/dashboard-usuario';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-cadastro-dashboard',
  templateUrl: './cadastro-dashboard.component.html',
  styleUrls: ['./cadastro-dashboard.component.css']
})
export class CadastroDashboardComponent implements OnInit {

  dashboard: Dashboard;
  dashboardUsuarios: DashboardUsuario[];

  paginacao: Paginacao;

  filtroPesquisaNomeUsuarioBind: string;

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';

  selecionados: boolean;
  public loading = false;
  public statusCode: number;

  constructor(
    private _dashboardsService: DashboardsService,
    private _comumService: ComumService,
    private _activatedRoute: ActivatedRoute,
    private _usuarioService: UsuarioService,
    private _cookieService: CookieService,
    private _authService: AuthService,
    private router: Router) {
    this.paginacao = new Paginacao();
    this.dashboard = new Dashboard();
    this.dashboardUsuarios = new Array<DashboardUsuario>();
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    const id = this._activatedRoute.snapshot.params['id'];
    this.loading = true;
    const self = this;
    const idCliente = parseInt(this._cookieService.get('idCliente'));

    if (id !== undefined) {
      forkJoin(this._usuarioService.obterUsuariosHttp(idCliente),
        this._dashboardsService.obterDashboardUsuarios(id),
        this._dashboardsService.obterDashboardPorIdHttp(id))
        .subscribe(([usuarios, dashboardUsuarios, dashboard]) => {
          self.dashboard = dashboard;
          for (const usuario of usuarios) {
            const novoDashboardUsuario = new DashboardUsuario();
            novoDashboardUsuario.usuario = usuario;
            novoDashboardUsuario.idDashboard = dashboard.idDashboard;
            for (const acessoVisaoUsuario of dashboardUsuarios) {
              if (acessoVisaoUsuario.usuario.idUsuario === usuario.idUsuario) {
                novoDashboardUsuario.idDashboardUsuario = acessoVisaoUsuario.idDashboardUsuario;
                novoDashboardUsuario.visualizar = acessoVisaoUsuario.visualizar;
                novoDashboardUsuario.alterar = acessoVisaoUsuario.alterar;
                break;
              }
            }
            self.dashboardUsuarios.push(novoDashboardUsuario);
          }
          self.loading = false;
          self.MODO = self.ATUALIZAR;
        });
    } else {
      this.dashboard.idCliente = idCliente;
      this._usuarioService.obterUsuariosHttp(idCliente)
        .subscribe((usuarios) => {
          for (const usuario of usuarios) {
            const novoDashboardUsuario = new DashboardUsuario();
            novoDashboardUsuario.usuario = usuario;
            self.dashboardUsuarios.push(novoDashboardUsuario);
          }
          self.MODO = self.CADASTRAR;
          self.loading = false;
        });
    }
  }

  onSubmit(): void {

    const self = this;

    if (this.MODO === this.CADASTRAR) {
      this._dashboardsService.cadastrarDashboardHttp(this.dashboard)
        .subscribe(response => {
          this.cadastrarPermissoesAcesso(response.body.idDashboard);
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-dashboards/']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    } else {
      this._dashboardsService.atualizarDashboardHttp(this.dashboard)
        .subscribe(response => {
          this.cadastrarPermissoesAcesso(this.dashboard.idDashboard);
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          self.router.navigate(['listar-dashboards/']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }

  }

  cadastrarPermissoesAcesso(idDashboard: number): void {
    const dashboardUsuariosInsert = new Array<DashboardUsuario>();
    const dashboardUsuariosUpdate = new Array<DashboardUsuario>();
    this.dashboardUsuarios.forEach(dashboardUsuario => {
      if (dashboardUsuario.idDashboardUsuario !== null
        && dashboardUsuario.idDashboardUsuario !== undefined) {
        dashboardUsuariosUpdate.push(dashboardUsuario);
      } else {
        dashboardUsuario.idDashboard = idDashboard;
        dashboardUsuariosInsert.push(dashboardUsuario);
      }
    });
    if (dashboardUsuariosUpdate.length > 0) {
      this._dashboardsService.atualizarDashboardUsuariosHttp(dashboardUsuariosUpdate)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-dashboards']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    if (dashboardUsuariosInsert.length > 0) {
      this._dashboardsService.cadastrarDashboardUsuariosHttp(dashboardUsuariosInsert)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-dashboards']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeUsuarioBind = filtro.value;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/dashboards/cadastro-dashboard/cadastro-dashboard.component.ts